import { render } from "./Science.vue?vue&type=template&id=11027d70&scoped=true"
import script from "./Science.vue?vue&type=script&lang=js"
export * from "./Science.vue?vue&type=script&lang=js"

import "./Science.vue?vue&type=style&index=0&id=11027d70&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11027d70"]])

export default __exports__